function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M65.2372 4.96161H19.6373V42.9616H65.2372V4.96161Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0705 8.1283H22.8039V39.7949H62.0705V8.1283Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6816 5.49856C19.6816 5.16719 19.9503 4.89856 20.2816 4.89856H64.5929C64.9242 4.89856 65.1929 5.16719 65.1929 5.49856V41.8246H67.67C68.0014 41.8246 68.27 42.0933 68.27 42.4246C68.27 42.756 68.0014 43.0246 67.67 43.0246H17.2045C16.8731 43.0246 16.6045 42.756 16.6045 42.4246C16.6045 42.0933 16.8731 41.8246 17.2045 41.8246H19.6816V5.49856ZM63.9929 41.8246V6.09856H20.8816V41.8246H63.9929ZM22.7588 8.57576C22.7588 8.24439 23.0274 7.97576 23.3588 7.97576H61.5157C61.8471 7.97576 62.1157 8.24439 62.1157 8.57576V39.3475C62.1157 39.6788 61.8471 39.9474 61.5157 39.9474H23.3588C23.0274 39.9474 22.7588 39.6788 22.7588 39.3475V8.57576ZM23.9588 9.17576V38.7475H60.9157V9.17576H23.9588Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/Picture.8683ac35ded16e228c3ecd126e0eee09.svg";
export { ForwardRef as ReactComponent };